function decodeHtml(str) {
	const t = document.createElement('textarea');
	t.innerHTML = str;
	return t.value;
}

const PAGE_SIZE = 12;
const LOAD_MORE_SIZE = 6;

let allEntries = [];
let filterIndex = { contentTypes: [], attorneys: [], practices: [], industries: [] };
let activeFilters = { contentType: '', attorney: '', practice: '', industry: '' };
let visibleCount = PAGE_SIZE;

let heroSlides = [];
let heroDots = [];
let heroCurrentIndex = 0;
let heroTimer = null;

const SVG_NS = 'http://www.w3.org/2000/svg';

const byTitle    = (a, b) => a.title.localeCompare(b.title);
const byLastName = (a, b) => (a.lastName || a.title).localeCompare(b.lastName || b.title) || a.title.localeCompare(b.title);

async function init() {
	const res = await fetch('/news-insights.json');
	const json = await res.json();
	allEntries = json.data;
	buildFilterIndex(allEntries);
	activeFilters = readUrlState();
	render();
	bindEvents();
	initHeroSlider();
}

function readUrlState() {
	const p = new URLSearchParams(window.location.search);
	return {
		contentType: p.get('contentType') || '',
		attorney:    p.get('attorney')    || '',
		practice:    p.get('practice')    || '',
		industry:    p.get('industry')    || '',
	};
}

function buildFilterIndex(entries) {
	const contentTypes = new Map(), attorneys = new Map(), practices = new Map(), industries = new Map();
	entries.forEach(e => {
		e.contentTypes.forEach(ct => contentTypes.set(ct.slug, ct));
		e.attorneys.forEach(a => attorneys.set(a.slug, a));
		e.practices.forEach(p => practices.set(p.slug, p));
		e.industries.forEach(i => industries.set(i.slug, i));
	});
	filterIndex = {
		contentTypes: [...contentTypes.values()].sort(byTitle),
		attorneys:    [...attorneys.values()].sort(byLastName),
		practices:    [...practices.values()].sort(byTitle),
		industries:   [...industries.values()].sort(byTitle),
	};
}

function applyFilters(entries, filters) {
	return entries.filter(e => {
		if (filters.contentType && !e.contentTypes.some(ct => ct.slug === filters.contentType)) return false;
		if (filters.attorney   && !e.attorneys.some(a => a.slug === filters.attorney))         return false;
		if (filters.practice   && !e.practices.some(p => p.slug === filters.practice))         return false;
		if (filters.industry   && !e.industries.some(i => i.slug === filters.industry))        return false;
		return true;
	});
}

function createInsightIcon() {
	const svg = document.createElementNS(SVG_NS, 'svg');
	svg.setAttribute('class', 'news-insights-home-card-icon');
	svg.setAttribute('width', '32.581');
	svg.setAttribute('height', '37.562');
	svg.setAttribute('viewBox', '0 0 32.581 37.562');
	svg.setAttribute('aria-hidden', 'true');

	const g = document.createElementNS(SVG_NS, 'g');
	g.setAttribute('transform', 'translate(19600.113 -7644)');

	[
		['M37.243,0a18.781,18.781,0,0,0,0,37.562Z', 'translate(-19604.775 7644)',   'var(--Periwinkle)'],
		['M18.78,0a18.781,18.781,0,0,0,0,37.562Z',  'translate(-19600.113 7644)',   'var(--Orange)'],
		['M23.442,8.089a18.77,18.77,0,0,0,0,25.468Z', 'translate(-19604.775 7641.958)', 'var(--Burgundy)'],
	].forEach(([d, transform, fill]) => {
		const path = document.createElementNS(SVG_NS, 'path');
		path.setAttribute('d', d);
		path.setAttribute('transform', transform);
		path.setAttribute('fill', fill);
		g.appendChild(path);
	});

	svg.appendChild(g);
	return svg;
}

function displayContentType(entry) {
	if (activeFilters.contentType) {
		const match = entry.contentTypes.find(ct => ct.slug === activeFilters.contentType);
		if (match) return match;
	}
	return entry.contentTypes[0];
}

function createCard(entry) {
	const a = document.createElement('a');
	a.href = entry.url;
	a.className = 'news-insights-home-card';

	if (entry.contentTypes.length) {
		const ct = displayContentType(entry);
		const label = document.createElement('p');
		label.className = 'news-insights-home-card-label';
		label.textContent = ct.titleSingular || ct.title;
		a.appendChild(label);
	}

	const h3 = document.createElement('h3');
	h3.textContent = decodeHtml(entry.title);
	a.appendChild(h3);

	const readMore = document.createElement('span');
	readMore.className = 'news-insights-home-card-read-more';
	readMore.textContent = 'READ MORE';
	a.appendChild(readMore);

	a.appendChild(createInsightIcon());
	return a;
}

function renderGrid(filtered) {
	const grid = document.getElementById('ni-grid');
	if (!grid) return;

	grid.replaceChildren();

	if (!filtered.length) {
		const empty = document.createElement('div');
		empty.className = 'news-insights-home-empty';
		const p = document.createElement('p');
		p.textContent = 'No results match your search. ';
		const a = document.createElement('a');
		a.href = window.location.pathname;
		a.textContent = 'View all';
		p.appendChild(a);
		p.append(' or try different filters.');
		empty.appendChild(p);
		grid.appendChild(empty);
	} else {
		const frag = document.createDocumentFragment();
		filtered.slice(0, visibleCount).forEach(entry => frag.appendChild(createCard(entry)));
		grid.appendChild(frag);
	}

	const btn = document.getElementById('ni-load-more');
	if (btn) btn.style.display = filtered.length > visibleCount ? '' : 'none';
}

function renderDropdowns(filters) {
	const preserve = (map, list, slug) => {
		if (slug && !map.has(slug)) {
			const found = list.find(o => o.slug === slug);
			if (found) map.set(slug, found);
		}
	};

	const forCt = applyFilters(allEntries, { ...filters, contentType: '' });
	const ctMap = new Map();
	forCt.forEach(e => e.contentTypes.forEach(ct => ctMap.set(ct.slug, ct)));
	preserve(ctMap, filterIndex.contentTypes, filters.contentType);

	const forAt = applyFilters(allEntries, { ...filters, attorney: '' });
	const atMap = new Map();
	forAt.forEach(e => e.attorneys.forEach(a => atMap.set(a.slug, a)));
	preserve(atMap, filterIndex.attorneys, filters.attorney);

	const forPr = applyFilters(allEntries, { ...filters, practice: '' });
	const prMap = new Map();
	forPr.forEach(e => e.practices.forEach(p => prMap.set(p.slug, p)));
	preserve(prMap, filterIndex.practices, filters.practice);

	const forIn = applyFilters(allEntries, { ...filters, industry: '' });
	const inMap = new Map();
	forIn.forEach(e => e.industries.forEach(i => inMap.set(i.slug, i)));
	preserve(inMap, filterIndex.industries, filters.industry);

	populateSelect('filter-contentType', [...ctMap.values()].sort(byTitle), 'Filter By Content Type', filters.contentType);
	populateSelect('filter-attorney',    [...atMap.values()].sort(byLastName), 'Filter By Attorney',     filters.attorney);
	populateSelect('filter-practice',    [...prMap.values()].sort(byTitle), 'Filter By Practice',     filters.practice);
	populateSelect('filter-industry',    [...inMap.values()].sort(byTitle), 'Filter By Industry',     filters.industry);
}

function populateSelect(id, options, placeholder, selectedSlug) {
	const sel = document.getElementById(id);
	if (!sel) return;

	sel.replaceChildren();

	const defaultOpt = document.createElement('option');
	defaultOpt.value = '';
	defaultOpt.textContent = placeholder;
	sel.appendChild(defaultOpt);

	const frag = document.createDocumentFragment();
	options.forEach(o => {
		const opt = document.createElement('option');
		opt.value = o.slug;
		opt.textContent = o.title;
		if (o.slug === selectedSlug) opt.selected = true;
		frag.appendChild(opt);
	});
	sel.appendChild(frag);

	const labelEl = sel.closest('.custom-select')?.querySelector('.custom-select-label');
	if (labelEl) {
		labelEl.textContent = selectedSlug
			? (options.find(o => o.slug === selectedSlug)?.title ?? placeholder)
			: placeholder;
	}
}

function updateAllButton() {
	const btn = document.getElementById('ni-filter-all');
	if (!btn) return;
	btn.classList.toggle('is-active', !Object.values(activeFilters).some(v => v !== ''));
}

function syncUrl(filters) {
	const p = new URLSearchParams();
	Object.entries(filters).forEach(([k, v]) => { if (v) p.set(k, v); });
	const qs = p.toString();
	history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
}

function render() {
	const filtered = applyFilters(allEntries, activeFilters);
	renderGrid(filtered);
	renderDropdowns(activeFilters);
	updateAllButton();
}

function bindEvents() {
	['filter-contentType', 'filter-attorney', 'filter-practice', 'filter-industry'].forEach(id => {
		document.getElementById(id)?.addEventListener('change', e => {
			const key = id.replace('filter-', '');
			activeFilters = { ...activeFilters, [key]: e.target.value };
			visibleCount = PAGE_SIZE;
			render();
			syncUrl(activeFilters);
		});
	});

	document.getElementById('ni-filter-all')?.addEventListener('click', () => {
		activeFilters = { contentType: '', attorney: '', practice: '', industry: '' };
		visibleCount = PAGE_SIZE;
		render();
		syncUrl(activeFilters);
	});

	document.getElementById('ni-load-more')?.addEventListener('click', () => {
		visibleCount += LOAD_MORE_SIZE;
		const filtered = applyFilters(allEntries, activeFilters);
		renderGrid(filtered);
	});

	window.addEventListener('popstate', () => {
		activeFilters = readUrlState();
		visibleCount = PAGE_SIZE;
		render();
	});
}

function initHeroSlider() {
	heroSlides = Array.from(document.querySelectorAll('.news-insights-home-hero-slide'));
	heroDots   = Array.from(document.querySelectorAll('.news-insights-home-hero-dot'));
	if (heroSlides.length <= 1) return;

	heroTimer = setInterval(advanceSlide, 4000);

	document.getElementById('ni-hero-dots')?.addEventListener('click', e => {
		const btn = e.target.closest('button');
		if (!btn) return;
		const idx = heroDots.indexOf(btn);
		if (idx < 0) return;
		clearInterval(heroTimer);
		showSlide(idx);
		heroTimer = setInterval(advanceSlide, 4000);
	});
}

function advanceSlide() {
	showSlide((heroCurrentIndex + 1) % heroSlides.length);
}

function showSlide(idx) {
	heroSlides.forEach((slide, i) => {
		slide.classList.toggle('is-active', i === idx);
		slide.setAttribute('aria-hidden', String(i !== idx));
	});
	heroDots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
	heroCurrentIndex = idx;
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.getElementById('ni-grid')) {
		init();
	}
});
